export default __webpack_public_path__ + "static/media/circle.02fd7405.png";